export default __webpack_public_path__ + "static/media/lucania-resine 1.03d1fd33.png";